/* eslint-disable no-unused-vars */
export enum PoolState {
  POOLSTATE_WAITING = '0', // Waiting, /// 대기 (다음 상태: 모금)
  POOLSTATE_FUNDRAISING = '1', // Fundraising, /// 모금 진행 (다음 상태: 운영 or 모금 잠김 or 모금 중지 or 모금 실패)
  POOLSTATE_FUNDRAISING_LOCKED = '2', // FundraisingLocked, /// 모금 잠김 (다음 상태: 운영)
  POOLSTATE_FUNDRAISING_STOPPED = '3', // FundraisingStopped, /// 모금 중지
  POOLSTATE_FUNDRAISING_FAILED = '4', // FundraisingFailed, /// 모금 실패
  POOLSTATE_OPERATING = '5', // Operating, /// 운영 (다음 상태: 운영 종료 or 운영 중지)
  POOLSTATE_OPERATING_CLOSED = '6', // OperatingClosed, /// 운영 종료
  POOLSTATE_OPERATING_STOPPED = '7', // OperatingStopped, /// 운영 중지
}
